import React from 'react';
import TranslateText from 'src/text/modal';

const distributersType = 'distributors'
const buyPoints = 'buyPoints'

function FinwhaleWeb({mapObjectTypes, setMapObjectTypes, finsalepoints, style}) {
  return (
    <div>
      <div
        style={{
          width: '80%',
          fontSize: 24,
          margin: '0 auto',
          fontWeight: 800,
          position: 'relative',
          ...(style || {})
        }}
      >
        <TranslateText id="fw_map__our_net" />
      </div>
      <div
        style={{
          width: '80%',
          margin: '0 auto',
          marginTop: 40,
          marginBottom: 20,
        }}
      >
        <TranslateText
          id="fw_map__distributers"
          style={{ display: 'inline-block' }}
          place="bottom"
          render={text => {
            return (
              <div
                style={{
                  padding: 10,
                  cursor: 'pointer',
                  display: 'inline-block',
                  paddingRight: 15,
                  ...(mapObjectTypes === distributersType ? {
                    boxShadow: 'inset 2px 2px 5px rgba(154, 147, 140, 0.5), 1px 1px 5px rgba(255, 255, 255, 1)',
                  } : {
                    boxShadow: 'rgba(0, 0, 0, 0.25) 1px 1px 5px, rgba(0, 0, 0, 0.22) -1px -1px 5px',
                  })
                }}
                onClick={() => {
                  setMapObjectTypes(distributersType)
                }}
              >
                <div
                  style={{
                    background: '#F00',
                    marginLeft: 10,
                    marginRight: 10,
                    width: 15,
                    display: 'inline-block',
                    height: 15,
                  }}
                />
                  {text}
              </div>
            );
          }}
        />
        <TranslateText
          id="fw_map__points_of_sale"
          style={{ display: 'inline-block' }}
          place="bottom"
          render={text => {
            return (
              <div
                style={{
                  padding: 10,
                  cursor: 'pointer',
                  display: 'inline-block',
                  paddingRight: 15,
                  marginLeft: 15,
                  ...(mapObjectTypes === buyPoints ? {
                    boxShadow: 'inset 2px 2px 5px rgba(154, 147, 140, 0.5), 1px 1px 5px rgba(255, 255, 255, 1)',
                  } : {
                    boxShadow: 'rgba(0, 0, 0, 0.25) 1px 1px 5px, rgba(0, 0, 0, 0.22) -1px -1px 5px',
                  })
                }}
                onClick={() => {
                  setMapObjectTypes(buyPoints)
                }}
              >
                <div
                  style={{
                    background: 'rgb(24, 183, 234)',
                    marginLeft: 10,
                    marginRight: 10,
                    width: 15,
                    display: 'inline-block',
                    height: 15,
                  }}
                />
                {text}
              </div>
            );
          }}
        />
      </div>
    </div>
  )
}

export default FinwhaleWeb



// WEBPACK FOOTER //
// ./src/finwhale/common/fw-map/Desktop.js